import React, { useRef, useEffect, useState } from 'react';
import { BaseButton, useT } from '@repo/common';

import { ReactComponent as CheckIcon } from '@repo/common/assets/icons/16px/icon_16px_check.svg';

// 목록 첫 줄의 안내 항목. 값은 그대로 두고 표시만 번역한다
const SENTINEL_LABELS = {
  'Select expected response time': '예상 응답 시간을 선택하세요',
};

function ResponseSpeedList({ onSelect, selectedOption }) {
  const t = useT();
  const options = [
    'Select expected response time',
    'Respond within 24h',
    'Respond within 48h',
    'No commitment',
  ];

  const listRef = useRef(null);
  const selectedRef = useRef(null);
  const [localSelected, setLocalSelected] = useState(selectedOption);

  useEffect(() => {
    if (listRef.current && selectedRef.current) {
      listRef.current.scrollTop = selectedRef.current.offsetTop - 8;
    }
  }, [selectedOption]);

  useEffect(() => {
    setLocalSelected(selectedOption);
  }, [selectedOption]);

  return (
    <div
      ref={listRef}
      className='w-full h-[170px] overflow-y-auto bg-grayscale-gray00 border border-grayscale-gray02 
                rounded-[15px] p-2 shadow-popup-02'
    >
      <ul role='menu' className='list-none p-0 m-0'>
        {options.map((option) => {
          const isSelected = option === localSelected;

          return (
            <div
              key={option}
              ref={isSelected ? selectedRef : null}
              className='flex items-center rounded-lg transition-colors duration-150'
            >
              <BaseButton
                type='text'
                size='m'
                bgclass='bg-grayscale-gray00'
                borderclass='border-none'
                textclass='justify-start'
                hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                width='100%'
                onMouseDown={() => {
                  setLocalSelected(option);
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setLocalSelected(option);
                  onSelect(option);
                }}
                leftalign='true'
                icon={
                  isSelected ? (
                    <CheckIcon className='text-icon-primary' />
                  ) : (
                    <span className='w-4 h-[18px]' />
                  )
                }
              >
                {SENTINEL_LABELS[option]
                  ? t(option, SENTINEL_LABELS[option])
                  : option}
              </BaseButton>
            </div>
          );
        })}
      </ul>
    </div>
  );
}

export default ResponseSpeedList;
